import { render, staticRenderFns } from "./followuprecord.vue?vue&type=template&id=63949fa5&"
import script from "./followuprecord.vue?vue&type=script&lang=js&"
export * from "./followuprecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports